module.exports = __webpack_public_path__ + "80d9559cf626b105eae02c683e34372e.otf";